module.exports = __webpack_public_path__ + "static/site-1783527333127/img/logo_cabal.f797e5ff.png";